import { Button, Col, Tooltip } from 'antd'
import React, { useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Translate } from 'react-translated'
import ViewAppoinmentModal from "./ViewAllAppointment"
// import { REVIEW } from '../../../../utils/Constants'

function EaDashboardChart({
  collapsed,
  state,
  props,
  refresh,
  appointment_name,
}) {
  const [isViewAppoinmentModal, setIsViewAppoinmentModal] = useState(false);
  return (
    <div className="">
      <Col
        style={{
          display: "flex",
          position: "relative",
          minHeight: "155px",
          overflow: "auto",
        }}
        lg={12}
        md={24}
        span={24}
        className="appointment_details width-100"
      >
        <div className="appointment_title">
          <Translate text={"Appointments"} />
        </div>
        <div
          style={{
            whiteSpace: "nowrap",
            bottom: "7px",
            left: "10px",
            position: "absolute",
          }}
        >
          <Button
            onClick={() => setIsViewAppoinmentModal(true)}
            style={{
              fontSize: 11,
              borderRadius: 20,
              fontWeight: 400,
              background: "#ECEAE9",
              color: "#1D1B20",
              height: 30,
            }}
            className="text-12"
          >
            View Appointments
          </Button>
          {isViewAppoinmentModal && (
            <ViewAppoinmentModal
              isViewAppoinmentModal={isViewAppoinmentModal}
              cancelViewAppoinmentModal={() => setIsViewAppoinmentModal(false)}
              history={props.history}
              dashboard={state.dashboard}
              filter_lsp={state.user.id}
              internalFilterChange={state.internalFilterChange}
              start_date={state.start_date}
              end_date={state.end_date}
              period={state.period}
              user={state.user}
              associations={state.associations}
              refresh={() => refresh()}
              appointment_name={appointment_name}
              isFromAllViewAppointment={true}
              type_of_call={state.type_of_call}
              is_lead={state.show_lead_card_appointment_details}
              // is_lead={state.is_lead}
              is_opportunity={state.is_opportunity}
              vonboard={state.vonboard}
              review={state.review}
            />
          )}
        </div>
        <div style={{ width: "60%", position: "absolute", right: 10 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                lineHeight: "normal",
                fontSize: 11,
                fontWeight: "normal",
                position: "relative",
              }}
            >
              <div
                // style={{ padding: "10px 25px" }}
                style={{
                  marginLeft: "0px",
                  paddingRight: "40px",
                }}
              >
                {
                  state.show_lead_card_appointment_details === 1
                  // state.is_lead == 1 
                  && (
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <span className="dotea lead" />
                      <div
                        style={{ marginLeft: 10, marginTop: -3, fontWeight: 500 }}
                      >
                        <div className="overflowchartcount  ">
                          <Tooltip
                            title={state.bfiles_counts.leads}
                            className="text-14"
                          >
                            {state.bfiles_counts.leads}
                          </Tooltip>
                        </div>
                        <div className="text-12">Leads</div>
                      </div>
                    </div>
                  )}
                {state.review === 1 && (
                  <div style={{ display: "flex", marginTop: 20 }}>
                    <span className="dotea review" />
                    <div
                      style={{ marginLeft: 10, marginTop: -3, fontWeight: 500 }}
                    >
                      <div className="overflowchartcount ">
                        <Tooltip
                          title={state.bfiles_counts.review}
                          className="text-14"
                        >
                          {state.bfiles_counts.review}
                        </Tooltip>
                      </div>
                      <div className="text-12" style={{ marginLeft: "10px" }}>
                        Review
                      </div>
                      {/* <div className='text-12'>Leads</div> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`chart-container ${(collapsed && "collapsed") || ""}`}
            >
              <Doughnut
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  tooltips: false,
                }}
                plugins={[
                  {
                    afterDraw: function (chart) {
                      const data = chart.data.datasets[0].data;
                      if (!data || data.every((item) => item === 0)) {
                        let ctx = chart.chart.ctx;
                        let width = chart.chart.width;
                        let height = chart.chart.height;
                        let margin = 10;
                        let radius = Math.min(width, height) / 2 - margin;

                        ctx.fillStyle = "#eceae9"; // Gray color fill
                        ctx.beginPath();
                        ctx.arc(width / 2, height / 2, radius, 0, 2 * Math.PI);
                        ctx.fill();

                        ctx.fillStyle = "#fff"; // White color fill
                        ctx.beginPath();
                        ctx.arc(
                          width / 2,
                          height / 2,
                          radius * 0.6,
                          0,
                          2 * Math.PI
                        );
                        ctx.fill();

                        // ctx.fillStyle = '#ffffff'; // White color fill
                        // ctx.fillRect(width / 2 - 50, height / 2 - 10, 100, 20); // Adjust position and size as needed

                        ctx.font = "10px Poppins"; // Font size
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";
                        ctx.fillStyle = "#000"; // black color fill
                      }
                    },
                  },
                ]}
                data={{
                  datasets: [
                    {
                      data: [
                        state.is_opportunity === 1
                          ? state.bfiles_counts.opportunity
                          : 0,
                        state.review === 1 ? state.bfiles_counts.review : 0,
                        state.show_lead_card_appointment_details === 1
                          // state.is_lead == 1
                          ? state.bfiles_counts.leads : 0,
                      ],
                      backgroundColor: [
                        state.is_opportunity === 1 ? "#E1A325" : "transparent",
                        state.review === 1 ? "#57AEFF" : "transparent",
                        state.show_lead_card_appointment_details === 1
                          // state.is_lead == 1
                          ? "#117521" : "transparent",
                      ],
                      hoverOffset: 4,
                    },
                  ],
                }}
              />
            </div>
            <div
              style={{
                lineHeight: "normal",
                fontSize: 11,
                fontWeight: "normal",
              }}
            >
              {state.is_opportunity === 1 && (
                <div
                  style={{ display: "flex", marginTop: 10, marginLeft: -25 }}
                >
                  <span className="dotea followup" />{" "}
                  <div
                    style={{ marginLeft: 10, marginTop: -3, fontWeight: 500 }}
                  >
                    <div className="overflowchartcount text-14">
                      <Tooltip title={state.bfiles_counts.opportunity}>
                        {state.bfiles_counts.opportunity}
                      </Tooltip>
                    </div>
                    <div className="text-12" style={{ marginRight: "10px" }}>
                      Opportunities
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
}

export default EaDashboardChart;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/EaDashboardCharts.js